import { useState } from 'react';

export default function ContactSection() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');
  const formUrl = 'http://chigualiao.cn/';

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formEl = e.currentTarget;
    const formData = new FormData(formEl);

    const phoneAlt = formData.get('phone_alt');
    if (phoneAlt && typeof phoneAlt === 'string' && phoneAlt.trim() !== '') {
      setStatus('success');
      formEl.reset();
      return;
    }

    try {
      const res = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        formEl.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
        setErrorMsg(msg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请检查连接后重试');
      setStatus('error');
    }
  };

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <span className="inline-block px-3 py-1 rounded-full text-xs font-medium border border-secondary-300 text-secondary-700 bg-secondary-50 mb-4">
                联系我们
              </span>
              <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-900 mb-4">
                投稿与合作
              </h2>
              <p className="text-foreground-600 text-sm leading-relaxed mb-8">
                有猛料想爆料？有合作意向？欢迎通过以下方式联系我们。
                我们会对投稿人信息严格保密，爆料一经采用将给予丰厚奖励。
              </p>
              <div className="flex flex-col gap-4">
                <div className="flex items-start gap-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600 flex-shrink-0">
                    <i className="ri-mail-line text-lg"></i>
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-900">电子邮箱</p>
                    <a href="mailto:hello@chigualiao.cn" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                      hello@chigualiao.cn
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600 flex-shrink-0">
                    <i className="ri-wechat-line text-lg"></i>
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-900">微信公众号</p>
                    <span className="text-sm text-foreground-600">搜索"51暗网"关注我们</span>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600 flex-shrink-0">
                    <i className="ri-time-line text-lg"></i>
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-900">工作时间</p>
                    <span className="text-sm text-foreground-600">7×24小时全天候在线</span>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <form
                id="contact-form"
               
                onSubmit={handleSubmit}
                className="bg-background-100 rounded-lg border border-background-200/70 p-6"
              >
                <div className="mb-4">
                  <label htmlFor="contact_name" className="block text-sm font-medium text-foreground-900 mb-1.5">
                    您的称呼 *
                  </label>
                  <input
                    type="text"
                    id="contact_name"
                    name="name"
                    required
                    className="w-full px-3 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入您的称呼"
                  />
                </div>
                <div className="mb-4">
                  <label htmlFor="contact_email" className="block text-sm font-medium text-foreground-900 mb-1.5">
                    电子邮箱 *
                  </label>
                  <input
                    type="email"
                    id="contact_email"
                    name="email"
                    required
                    className="w-full px-3 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
                <div className="mb-4">
                  <label htmlFor="contact_subject" className="block text-sm font-medium text-foreground-900 mb-1.5">
                    主题 *
                  </label>
                  <select
                    id="contact_subject"
                    name="subject"
                    required
                    className="w-full px-3 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors cursor-pointer"
                  >
                    <option value="">请选择主题</option>
                    <option value="投稿爆料">投稿爆料</option>
                    <option value="商务合作">商务合作</option>
                    <option value="广告投放">广告投放</option>
                    <option value="意见建议">意见建议</option>
                    <option value="其他">其他</option>
                  </select>
                </div>
                <div className="mb-4">
                  <label htmlFor="contact_message" className="block text-sm font-medium text-foreground-900 mb-1.5">
                    详细内容 *
                  </label>
                  <textarea
                    id="contact_message"
                    name="message"
                    required
                    maxLength={500}
                    rows={4}
                    className="w-full px-3 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                    placeholder="请描述您的投稿内容或合作需求（最多500字）"
                  ></textarea>
                  <p className="text-[11px] text-foreground-400 mt-1">最多500个字符</p>
                </div>

                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="form-anti-spam-field"
                />

                {status === 'success' && (
                  <div className="mb-4 p-3 rounded-lg bg-green-50 border border-green-200 text-sm text-green-700">
                    提交成功！我们会尽快处理您的信息，感谢您的关注。
                  </div>
                )}
                {status === 'error' && (
                  <div className="mb-4 p-3 rounded-lg bg-red-50 border border-red-200 text-sm text-red-700">
                    {errorMsg}
                  </div>
                )}

                <button
                  type="submit"
                  className="w-full px-4 py-2.5 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  提交信息
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}